import firebase from 'firebase';
import { useAtom } from 'jotai';
import { useCollectionData } from 'react-firebase-hooks/firestore';
// state
import { userRecordAtom } from '../../../../shared/state/atoms';
// constants
import { FIRESTORE_FIELDS, FIRESTORE_KEYS } from '../../../../shared/utils/constants';

export default function useTeacherList() {
  const [user] = useAtom(userRecordAtom);
  const {SCHOOL} = FIRESTORE_FIELDS

  const [teacherList] = useCollectionData(
    firebase
      .firestore()
      .collection(FIRESTORE_KEYS.TEACHERS)
      .where(SCHOOL.ID, '==', user?.school?.id || ''),
    { idField: 'id' }
  );

  return { teacherList };
}
